import PropTypes from "prop-types";
import BottomNavbar from "../components/navs/mobilenav";

const DashCard = ({ children, className }) => {
  return (
    <div className="font-sora ">
         <div className={`bg-white  p-0  mt-18 sm:p-6   md:rounded-3xl md:shadow-md flex flex-col divide-y divide-gray-200 ${className}`}>
          
      {children}
    </div>
    <BottomNavbar/>
    </div>
   
  );
};

DashCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

DashCard.defaultProps = {
  className: "",
};

export default DashCard;
